import React from "react"
import { FormattedDate, FormattedTime, FormattedMessage } from "react-intl"
import { Button } from "react-bootstrap"

import { parseDate } from "../../shared_components/utils"
import { getFormattedMessage } from "../shared_components_registration"

export function LocaleFormattedDate({ date, shouldParse = false, showTime = true }) {
  const finalDate = date && shouldParse ? parseDate(date) : date
  if (finalDate) {
    return (
      <React.Fragment>
        <FormattedDate value={finalDate} year={"numeric"} month={"short"} day={"2-digit"} />
        {showTime && (
          <>
            &nbsp;
            <FormattedTime
              value={finalDate}
              hour12={false}
              hour={"numeric"}
              minute={"numeric"}
              second={"numeric"}
            />
          </>
        )}
      </React.Fragment>
    )
  } else {
    return ""
  }
}

export function LocaleFormattedUser({ user }) {
  const { first_name, last_name, username } = user
  if (!first_name || !last_name) {
    return <>{username || "-"}</>
  }

  return (
    <FormattedMessage
      id={"internationalized.name"}
      description={"Returns User Name"}
      defaultMessage={`${first_name} ${last_name}`}
      values={{ first: first_name, last: last_name }}
    />
  )
}

export function getLocaleFormattedUserString(user = {}, intl) {
  const { first_name, last_name, username } = user
  const formattedName = getFormattedMessage(
    "internationalized.name",
    `${first_name} ${last_name}`,
    true,
    intl,
    {
      first: first_name,
      last: last_name,
    },
  )
  if (!first_name || !last_name) {
    return username || "-"
  }
  return formattedName
}

export function RequiredFieldWarning(props) {
  const { warning } = props

  return (
    <p className={"warning-message"} style={{ display: warning ? "block" : "none", marginLeft: "2px" }}>
      <FormattedMessage
        id={"general.warning.requiredFormField"}
        description={"Warning Message For Missing Required Field"}
      />
    </p>
  )
}

export function CloseButton({ onClose, variant = "outline-primary", disabled = false }) {
  return (
    <Button variant={variant} disabled={disabled} onClick={onClose}>
      <FormattedMessage id={"general.closeButton"} description={"Close"} defaultMessage={"Close"} />
    </Button>
  )
}
